import { FC, memo, useEffect, useRef } from 'react';
import { HeroConversation } from '@vs-online-only-app/state';
import { ConversationItemsPlaceholder } from './ConversationsItemsPlaceholder';
import ConversationItemCard from './ConversationItemCard';
import { CenteredLoader } from '@vs-online-only-app/ui';

type Props = {
  archivedConversations: HeroConversation[];
  fetchNextPage: () => void;
  isFetching: boolean;
};

const ArchivedConversationsList: FC<Props> = ({
  archivedConversations,
  fetchNextPage,
  isFetching,
}) => {
  const listRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const list = listRef.current;
    const handleScroll = () => {
      if (list && list.scrollTop === list.scrollHeight - list.clientHeight) {
        fetchNextPage();
      }
    };
    list?.addEventListener('scroll', handleScroll);
    return () => list?.removeEventListener('scroll', handleScroll);
  }, [archivedConversations, fetchNextPage]);

  if (archivedConversations.length === 0) {
    return <ConversationItemsPlaceholder />;
  }

  return (
    <>
      {isFetching && <CenteredLoader />}
      {archivedConversations.map((conversation) => (
        <ConversationItemCard
          conversation={conversation}
          key={conversation.id}
        />
      ))}
    </>
  );
};

export default memo(ArchivedConversationsList);
